import { render, staticRenderFns } from "./cabinetManage.vue?vue&type=template&id=79a82484"
import script from "./cabinetManage.vue?vue&type=script&lang=js"
export * from "./cabinetManage.vue?vue&type=script&lang=js"
import style0 from "./cabinetManage.vue?vue&type=style&index=0&id=79a82484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports